export default __webpack_public_path__ + "static/media/Icons_Share_Share_iOS_Bold.157da142.svg";